import { render, staticRenderFns } from "./traitement-demande-fiche-aim.vue?vue&type=template&id=223ebd18&scoped=true"
import script from "./traitement-demande-fiche-aim.vue?vue&type=script&setup=true&lang=js"
export * from "./traitement-demande-fiche-aim.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223ebd18",
  null
  
)

export default component.exports